const API_URL = import.meta.env.VITE_API_URL;

const handleResponse = async (response) => {
    const isJson = response.headers.get('Content-Type')?.includes('application/json');
    const data = isJson ? await response.json() : await response.text();

    if (!response.ok) {
        throw new Error(
            (data.message || data) || `Erro HTTP: ${response.status}`
        );
    }

    return data;
};

const getAuthHeader = () => {
    const token = localStorage.getItem('access_token');
    if (!token) throw new Error('Token de acesso não encontrado');
    return { 'Authorization': `Bearer ${token}` };
};


export const getArticles = async () => {
    try {
        const response = await fetch(`${API_URL}/api/articles`);
        return await handleResponse(response);
    } catch(error) {
        throw new Error(`Falha ao buscar artigos: ${error.message}`);
    }
};

export const createArticles = async (article) => {
    try {
        const response = await fetch(`${API_URL}/api/articles`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeader()
            },
            body: JSON.stringify(article)
        });
        return await handleResponse(response);
        
    } catch(error) {
        throw new Error(`Erro ao criar artigo: ${error.message}`);
    }
};

export const change_article = async (article) => {
    try {
        const response = await fetch(`${API_URL}/api/articles/${article.id}`, {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json',
                ...getAuthHeader()
            },
            body: JSON.stringify(article)
        });
        return await handleResponse(response);
        
    } catch(error) {
        throw new Error(`Erro ao atualizar artigo: ${error.message}`);
    }
};

export const deleteArticle = async (id) => {
    try {
        const response = await fetch(`${API_URL}/api/articles/${id}`, {
            method: 'DELETE',
            headers: { ...getAuthHeader() }
        });
        return await handleResponse(response);
        
    } catch(error) {
        throw new Error(`Erro ao deletar artigo: ${error.message}`);
    }
};

export const loginUser = async (username, password) => {
    try {
        const response = await fetch(`${API_URL}/api/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ username, password })
        });

        const data = await response.json();
        if (!response.ok || !data.access_token) {
            throw new Error(data.message || 'Credenciais inválidas');
        }
        localStorage.setItem('access_token', data.access_token);
        return data;
    } catch (error) {
        console.error('Erro no login:', error);
        throw new Error(`Falha ao fazer login: ${error.message}`);
    }
};